module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner",
    class: _vm.size,
    style: (_vm.style)
  }, [_c('div', {
    staticClass: "bounce1"
  }), _vm._v(" "), _c('div', {
    staticClass: "bounce2"
  }), _vm._v(" "), _c('div', {
    staticClass: "bounce3"
  })])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-6a5d193b", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a5d193b"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/loaders/loader1.vue
// module id = 848
// module chunks = 0